<template>
  <TabBox
    :options="optionsStudy"
    :tab="soltab"
    :scrollToActiveTab="scrollToActiveTab"
    :hasNamedTabSlot="true"
    class="tabboxstudy"
    style="
      --clr-tbbox-tab-hover-back: var(--clr-black-1);
      --clr-tbbox-tab-active-back: var(--clr-black-1);
    "
    @click="set_soltab"
  >
    <template #tabs_after>
      <slot
        name="tabs_after"
        :tab="soltab"
      />
    </template>
    <template #tab_strategy>
      <div
        id="strategy_tab"
        @click.stop="switch_stratab()"
      >
        {{ $t(`tabs.${stratab}`) }}
      </div>
      <GwMenu
        ref="gwmenu"
        @click.stop
      >
        <template #opener="{ value }">
          <div
            class="mdi text-semi-large transition_03 icon_btn mdi-menu-down gtabs_menu_icon transition_03"
            :class="{ rotated_180_before: value }"
            data-tst="stramenu_opener"
            style="margin: 0 -0.5rem 0 0.25rem; transition: 0.22s"
          />
        </template>
        <template #default="{ methods }">
          <GwBtns
            :value="stratab"
            :options="optionsStrategy"
            tstPrefix="strabtn"
            idKey="payload"
            class="gwbtns_vertical_primary gw_menu"
            @click="
              (_e, item) => {
                set_stratab(item, 'force'), methods.toggleOpen(false)
              }
            "
          >
            <template #default="{ item }">
              {{ $t(`tabs.${item}`) }}
            </template>
            <template #after>
              <div class="bt-grey my-1"></div>
              <div
                class="gw_btn gw_btn_text gw_btn_small clr-grey text-small f-justify-start bt-grey"
                style="--padding: 0.5rem"
                @click="
                  methods.toggleOpen(false),
                    $store.dispatch('router_set_dialogs', 'study-strategy-help-dialog')
                "
              >
                <i class="mdi mdi-help-circle-outline mr-1 text-medium" />
                {{ $t('common.help') }}
              </div>
            </template>
          </GwBtns>
        </template>
      </GwMenu>
    </template>
    <template #tab_reports>
      <div
        id="strategy_tab"
        @click.stop="switch_reptab()"
      >
        {{ $t(`common.reports_xxx`, { str: $t(`switchers.${reptab}`) }) }}
      </div>
      <GwMenu
        ref="gwmenu"
        @click.stop
      >
        <template #opener="{ value }">
          <div
            class="mdi text-semi-large transition_03 icon_btn mdi-menu-down gtabs_menu_icon"
            :class="{ rotated_180_before: value }"
            style="margin: 0 -0.5rem 0 0.25rem; transition: 0.22s"
            data-tst="reports_opener"
          />
        </template>
        <template #default="{ methods }">
          <GwBtns
            :value="reptab"
            :options="reportsOptions"
            idKey="payload"
            class="gwbtns_vertical_primary gw_menu"
            @click="
              (_e, item) => {
                set_reptab(item, 'force')
                methods.toggleOpen(false)
              }
            "
          >
            <template #default="{ item }">
              {{ $t(`switchers.${item}`) }}
            </template>
          </GwBtns>
        </template>
      </GwMenu>
      <!--LoaderProgressSpinner
        v-if="isCustomReportsPending"
        :progress="customReportsPercentage || $t('common.loading')"
        style="padding-left: 0.5rem"
        progress-position="right"
      /-->
    </template>
    <template #tab_range>
      {{ $t(`tabs.range`) }}
      <GuideTooltip
        v-if="hasGuide"
        :isInside="false"
        placement="top"
        guide="range_tab"
        style="position: absolute; right: 0rem; top: 0px"
      />
    </template>
    <template #tab_breakdown>
      {{ $t(`tabs.breakdown`) }}
      <GuideTooltip
        v-if="hasGuide"
        :isInside="false"
        placement="top"
        guide="breakdown_tab"
        style="position: absolute; right: 0rem; top: 0px"
      />
    </template>

    <template #default="{ tab }">
      <div
        class="tabboxstudy_content swp_cont"
        data-tst="tabboxstudy_content"
        @touchstart="swpHandleTouchStart"
        @touchmove="swpHandleTouchMove"
        @touchend="e => swpHandleTouchEnd(e, { swKey: 'sw_tabs_study' })"
      >
        <slot :tab="tab"></slot>
      </div>
    </template>
  </TabBox>
</template>

<script>
import TabBox from '@/components/lib/TabBox'
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'
import GuideTooltip from '@/components/Study/Switchers/GuideTooltip'
import { allSwitchers } from '@/store/switchers/switchers'
import swipe_mix from '@/mixins/swipe_mix'
// import LoaderProgressSpinner from '@/components/Loaders/LoaderProgressSpinner.vue'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'TabBoxStudy',
  components: {
    TabBox,
    GwMenu,
    GwBtns,
    GuideTooltip,
    // LoaderProgressSpinner,
  },
  mixins: [swipe_mix],
  props: {
    namespace: { type: String, default: '' },
    hasGuide: { type: Boolean, default: true },
    hasFullscreen: { type: Boolean, default: true },
    scrollToActiveTab: Boolean,
    reportsStreet: { default: 'preflop' },
    isCustomReportsPending: { type: Boolean, default: false },
    customReportsPercentage: { type: Number, default: 0 },
  },
  data() {
    const sws = allSwitchers()
    this.swTabsStudy = sws.sw_tabs_study
    this.swTabsStrategy = sws.sw_tabs_strategy
    this.optionsStrategy = this.swTabsStrategy.map(i => i.payload)
    this.swTabsReportsFlop = sws.sw_reports_flop_grouping
    this.optionsReportsFlop = this.swTabsReportsFlop.map(i => i.payload)
    this.swTabsReportsTurn = sws.sw_reports_turn_grouping
    this.optionsReportsTurn = this.swTabsReportsTurn.map(i => i.payload)
    return {}
  },
  // #Exeption Soltab
  // During created() hook Soltab is set from StudySolutions.vue
  methods: {
    set_switcherItem({ options, payload, key, queryKey }) {
      const item = options.find(i => i.payload === payload)
      if (!item) {
        return
      }

      this.$store.dispatch(SNK('router_update_query', this.namespace), {
        query: { [queryKey]: payload },
        push: false,
        replace: true,
        saveLocally: true,
      })

      setTimeout(() => {
        // Router is async so we have to wait
        this.$store.dispatch('switchers_set_item', {
          key,
          item,
        })
      })
    },
    set_reptab(payload, force) {
      if (this.soltab !== 'reports') {
        this.set_soltab('reports')
        if (!force) {
          return
        }
      }
      const key =
        this.reportsStreet === 'turn' ? 'sw_reports_turn_grouping' : 'sw_reports_flop_grouping'
      const queryKey = this.reportsStreet === 'turn' ? 'repturntab' : 'repfloptab'
      const opts = this.reportsStreet === 'turn' ? this.swTabsReportsTurn : this.swTabsReportsFlop
      this.set_switcherItem({
        key,
        options: opts,
        payload,
        queryKey,
      })
    },
    //-------
    swpLeft(eventData, { swKey }) {
      if (eventData.e.gw_touchends) {
        // console.log('swpLeft', eventData.e.gw_touchends)
        // scroll ro the end (right) wait a bit and then switch on second swipe
        if (
          !eventData.e.gw_touchends.some(
            i => i.ist_right && !i.ist_first && Date.now() - i.ist_right_time > 444,
          )
        )
          return
      }
      const nextItem = this.$store.getters.switchers_getNext({ key: swKey, num: 1 })
      this.set_soltab(nextItem.payload)
    },
    swpRight(eventData, { swKey }) {
      if (eventData.e.gw_touchends) {
        // console.log('swpRight', eventData.e.gw_touchends)
        // allow for move back instantly on first swipe right
        // if scrolled to right scrolled to left wait a bit and then switch on second swipe
        if (
          !eventData.e.gw_touchends.some(
            i => i.ist_left && (i.ist_first || Date.now() - i.ist_left_time > 444),
          )
        )
          return
      }
      const nextItem = this.$store.getters.switchers_getNext({ key: swKey, num: -1 })
      this.set_soltab(nextItem.payload)
    },
    swpUp(eventData, args) {
      if (this.soltab === 'range') {
        const swKey = eventData.e.gw_raTable_swKey
        if (swKey) {
          this.$store.dispatch('switchers_set_next', { key: swKey, num: -1 })
        }
        return
      }
      if (this.soltab === 'strategy') {
        this.switch_stratab(-1)
      }
    },
    swpDown(eventData, args) {
      if (this.soltab === 'strategy') {
        this.switch_stratab(1)
        return
      }
      if (this.soltab === 'range') {
        const swKey = eventData.e.gw_raTable_swKey
        if (swKey) {
          this.$store.dispatch('switchers_set_next', { key: swKey, num: 1 })
        }
      }
    },
    set_soltab(payload, sync = true) {
      // syncing reports and study tabs as if there was no split
      if (sync) {
        this.$store.dispatch('poker_sync_study_tabs', { soltab: payload })
      }

      this.set_switcherItem({
        key: 'sw_tabs_study',
        options: this.swTabsStudy,
        payload,
        queryKey: 'soltab',
      })
      if (this.stratab === 'ev_compare') {
        this.set_handstab('ev_compare')
      }
      this.$store.dispatch('globals_action', `horizontal_scroll_check`)
    },
    set_handstab(payload) {
      this.$store.dispatch('switchers_set_item', {
        key: 'sw_tabs_handmatrix_all',
        item: { payload },
      })
    },
    set_stratab(payload, force) {
      if (payload === 'ev_compare') {
        this.set_handstab('ev_compare')
      }
      if (this.soltab !== 'strategy') {
        this.set_soltab('strategy')
        if (!force) {
          return
        }
      }
      this.set_switcherItem({
        key: 'sw_tabs_strategy',
        options: this.swTabsStrategy,
        payload,
        queryKey: 'stratab',
      })
    },
    switch_reptab(num = 1) {
      let idx = 0
      const opts = this.reportsStreet === 'turn' ? this.swTabsReportsTurn : this.swTabsReportsFlop
      idx = opts.findIndex(i => i.payload === this.reptab)
      let item = opts[idx + num]
      item = !item && num === 1 ? opts[0] : !item && num === -1 ? opts[opts.length - 1] : item
      this.set_reptab(item.payload)
    },
    switch_stratab(num = 1) {
      let idx = 0
      const opts = this.swTabsStrategy
      idx = opts.findIndex(i => i.payload === this.stratab)
      let item = opts[idx + num]
      item = !item && num === 1 ? opts[0] : !item && num === -1 ? opts[opts.length - 1] : item
      this.set_stratab(item.payload)
    },
  },
  computed: {
    optionsStudy() {
      return this.swTabsStudy.map(i => i.payload)
    },
    soltab() {
      return this.$store.getters.sw_tabs_study
    },
    stratab() {
      return this.$store.getters.sw_tabs_strategy
    },
    reptab() {
      return this.reportsStreet === 'turn'
        ? this.$store.getters.sw_reports_turn_grouping
        : this.$store.getters.sw_reports_flop_grouping
    },
    reportsOptions() {
      return this.reportsStreet === 'turn' ? this.optionsReportsTurn : this.optionsReportsFlop
    },
    query_soltab() {
      return this.$route.query.soltab
    },
    hotkeysPressedBottom() {
      return this.$store.getters.hotkeys_pressed_bottom
    },
  },
  watch: {
    '$store.getters.sw_tabs_strategy': {
      handler(newVal, oldVal) {
        if (newVal === oldVal) return
        this.$store.commit('sol_detail_set', {
          player: '0',
          value: newVal,
          key: 'players_detail',
          playerProperty: 'strategy_content',
        })
      },
      immediate: true,
    },
    hotkeysPressedBottom(keys) {
      if (!keys) return
      const hotkeyActions = {
        strategy_forward: { keys: ['1'], fn: () => this.switch_stratab() },
        strategy_backward: { keys: ['shift', '1'], fn: () => this.switch_stratab(-1) },
        range: { keys: ['2'], fn: () => this.set_soltab('range') },
        breakdown: { keys: ['3'], fn: () => this.set_soltab('breakdown') },
        reports_forward: { keys: ['4'], fn: () => this.switch_reptab() },
        reports_backward: { keys: ['shift', '4'], fn: () => this.switch_reptab(-1) },
      }
      this.$store.dispatch('hotkeys_perform_action', { keys, hotkeyActions })
    },
    query_soltab() {
      if (this.soltab !== this.query_soltab) {
        this.set_soltab(this.query_soltab)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.tabboxstudy {
  --tbbox-content-gap: 0 !important;
  --tbbox-content-padding: 0 !important;
  --tbbox-content-clr-back: transparent !important;
  &_content {
    display: flex;
    min-height: 100%;
    min-width: 100%;
  }
}
</style>
